import { render, staticRenderFns } from "./reqpurchaseV0.vue?vue&type=template&id=1c24cdb3&scoped=true"
import script from "./reqpurchaseV0.vue?vue&type=script&lang=js"
export * from "./reqpurchaseV0.vue?vue&type=script&lang=js"
import style0 from "./reqpurchaseV0.vue?vue&type=style&index=0&id=1c24cdb3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c24cdb3",
  null
  
)

export default component.exports